import { createWidget } from '@alfa-bank/site-util-create-widget';
import { ProgressBarV2 as ProgressBar } from '@alfa-bank/site-progress-bar-v2';

import { FormProgressBarV2 as Component } from './form-progress-bar-v2';
import type { TFormProgressBarV2, IDeps } from './models';

export const FormProgressBarV2 = createWidget<IDeps, TFormProgressBarV2>({
    ProgressBar,
})(Component);
